import React, { useState } from "react";
import { object, number } from "prop-types";
import { format } from "date-fns";

import StoryHeader from "../story-header";
import { StoryCard } from "../story-elements";
// import Tags from "../story-elements/tags";
import StorySideBar from "../story-sidebar";
import KeyEvents from "./key-events";

import "./live-blog.m.css";
import Tags from "../story-elements/tags";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import ReadMoreButton from "../../atoms/read-more";
import SocialMediaShare from "../../molecules/social-media-share";
import StorySeparator from "../../atoms/story-separator";

const TimeStamp = ({ card, story }) => {
  const time = format(card["card-added-at"], "kk:mm");
  const date = format(card["card-added-at"], "dd MMM yyyy");

  const [toggleSharing, setToggleSharing] = useState(false);
  const sharingHandler = () => {
    setToggleSharing(!toggleSharing);
  };

  return (
    <div styleName="event-date">
      <div styleName="event-data">
        <span>{time}</span>
        <span>{date}</span>
      </div>
      <div styleName="share-icon-wrapper">
        <button styleName="share" onClick={sharingHandler}>
          <SvgIconHandler type="shareicon" />
        </button>
        <div styleName="share-options">{toggleSharing && <SocialMediaShare story={story} />}</div>
      </div>
    </div>
  );
};

TimeStamp.propTypes = {
  story: object,
  card: object
};

const LiveBlogStoryTemplate = ({ story, index }) => {
  const [showReadMore, setShowReadMore] = useState(true);
  const [showCards, setShowCards] = useState(10);

  const cardsLength = story.cards.length - 1;

  const handleReadMore = () => {
    setShowReadMore(false);
    setShowCards(story.cards.length);
    window.dataLayer.push({
      event: "liveBlog"
    });
  };

  return (
    <>
      {index > 0 && <StorySeparator />}
      <div styleName="story-wrapper">
        <div id={`story-content-${story.id}`} className="story-section">
          <div>
            <StoryHeader story={story} isLiveBlog={true} />
            {story["owner-name"].toLowerCase() !== "migrator" && <KeyEvents story={story} />}
            <div styleName="story-cards">
              {story.cards.slice(0, showCards).map((card, index) => {
                return (
                  <div key={index}>
                    <div styleName={`event-item ${index !== cardsLength ? "event-item-brd" : ""}`} key={index}>
                      <TimeStamp card={card} story={story} />
                      <div styleName="event-content" id={"card" + card.id}>
                        <StoryCard card={card} story={story} key={index} />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {story.cards.length >= 10 && showReadMore ? (
              <ReadMoreButton text="ಇನ್ನಷ್ಟು ಓದಿ" onClick={handleReadMore} className="buttonWrapper" />
            ) : null}
            <Tags story={story} />
          </div>
        </div>
        <StorySideBar index={index} story={story} />
      </div>
    </>
  );
};

LiveBlogStoryTemplate.propTypes = {
  story: object,
  index: number,
  card: object
};

const LiveBlogStory = (props) => {
  return <LiveBlogStoryTemplate story={props.story} index={props.index} />;
};

LiveBlogStory.propTypes = {
  story: object,
  index: number
};

export default LiveBlogStory;
